import React from "react";
import COR from "../../PicesForPages/CashOutRefinance.jpg";
import FreeConsultation from "../Form/FreeConsultation";

function CashOutRefinance() {
  return (
    <div className="purchaseParent">
      <div className="purchasetopParent CashOutRefinancePageTopParent">
        <img
          fetchPriority="high"
          loading="eager"
          src={COR}
          alt="CORImage"
          className="background-video CORImage"
        />
        <div className="purchasetopBox CashOutRefinancePageTopBox">
          {/* The existing Purchase span */}
          <span>Cash Out Refinance</span>
        </div>
      </div>
      <div className="purchaseBottomParent">
        <div className="purchaseBottomBox">
          <div className="purchaseBottomLeftBox">
            <span className="purchaseBottomLeftContent">
              Kindly note that refinancing your current loan may result in
              higher total finance charges over the life of the new loan.
            </span>

            <span className="purchaseBottomLeftContent">
              Please remember that replacing your existing loan with a refinance
              could increase the overall finance charges across its full term.
            </span>

            <span className="purchaseBottomLeftHeader">
              What benefits does this provide?{" "}
            </span>
            <span className="purchaseBottomLeftContent">
              By leveraging your home’s equity, you can unlock cash to pay off
              debts or manage upcoming expenses. Refinancing may also help you
              secure a more competitive mortgage interest rate, potentially
              reducing your monthly payments. In addition, the interest paid may
              be tax-deductible.
            </span>

            <span className="purchaseBottomLeftHeader">
              How can we support you?
            </span>
            <span className="purchaseBottomLeftContent">
              If you’re considering this refinancing option,{" "}
              <span className="brand_text">VIDHI MORTGAGE LLC</span> is prepared
              to identify a solution tailored to your financial goals. We
              provide cash-out refinance programs for both owner-occupied and
              investment properties, with competitive and affordable rates.
            </span>

            <div className="purchaseBottomLeftButton">
              <a
                href="https://vidhimortgage.my1003app.com/"
                target="_blank"
                rel="noreferrer"
                className="purchaseBottomLeftButtonLink"
              >
                Apply Now
              </a>
            </div>
          </div>
          <FreeConsultation />
        </div>
      </div>
    </div>
  );
}

export default CashOutRefinance;
